module.exports = __webpack_public_path__ + "static/img/zhao-top.7b8ed85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhao-top.png
// module id = BOk5
// module chunks = 0